import { render, staticRenderFns } from "./StageAction.vue?vue&type=template&id=18fad56f&scoped=true"
import script from "./StageAction.vue?vue&type=script&lang=js"
export * from "./StageAction.vue?vue&type=script&lang=js"
import style0 from "./StageAction.vue?vue&type=style&index=0&id=18fad56f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fad56f",
  null
  
)

export default component.exports